import { createContext } from "react";

export interface CartUIContextType {
  isDrawerOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
}

export const CartUIContext = createContext<CartUIContextType | undefined>(
  undefined,
);
